import { render, staticRenderFns } from "./ArchiveOrdersPage.vue?vue&type=template&id=af65dfae"
import script from "./ArchiveOrdersPage.vue?vue&type=script&lang=js"
export * from "./ArchiveOrdersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports